module.exports = __webpack_public_path__ + "static/media/ctgaming.b744990d.png";